module.exports = __webpack_public_path__ + "static/media/0238_Small.7d9589d9.jpg";